import { I18n } from "react-redux-i18n";
import { getPaymentMethod } from "../tableMatePaid";

export const generate_sam4s = (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => {
    var url = "";
    var sam4s = {
        5: "A00",
        18: "B00",
        27: "C00",
        s5: "A00",
        s18: "B00",
        s27: "C00",
        null: "D00",
        undefined: "D00",
        0: "D00",
        snull: "D00",
        sundefined: "D00",
        s0: "D00",
    };


    var services = {};

    url = "PTG|1";

    Object.values(amounts).sort((a, b) => a.entryOrder - b.entryOrder).filter(category => category.amount + category.service_amount).forEach(category => {
        if (category.amount) {
            //eslint-disable-next-line no-useless-concat
            url += "\\1|" + category.name.replace(/\p{Extended_Pictographic}/gu, '').trim() + " " + "||" + ("" + category.amount).replace(",", ".") + "|" + category.count + "|db|" + (category.count * category.amount) + "|" + sam4s[category.vat] + "||";
        }
        if (category.service_amount > 0) {
            if (!services[category.vat]) {
                services[category.vat] = 0;
            }
            services[category.vat] += category.service_amount * category.count;
        }
    });

    Object.keys(services).forEach(key => {
        url += "\\1|" + (services[key] > 2 ? I18n.t("admin_local.fiscat_service_fee") + " (" + I18n.t("admin_local.vat") + " " + key + "% ÁFA)" : I18n.t("admin_local.rounding")) + "||" + ("" + services[key]).replace(",", ".") + "|1|db|" + ("" + services[key]).replace(",", ".") + "|" + sam4s["s" + key] + "||";
    });


    var paymentMethods = {
        "cash": "1",
        "card": "2",
        "hellopay": "2",
        "teya": "2",
        "online": "2",
        "bizpay": "2",
        "paynance": "2",
        "utalvany": "16",
    }

    types.filter(t => t.amount > 0).forEach((t, ind) => {
        if (ind > 0)
            url += "|";
        const paymentMethod = getPaymentMethod(t.type);

        //var roundFunction = auth.myStatus.restaurant_base_currency["javaScriptRoundFunction"];
        var amount = t.amount;
        // eslint-disable-next-line no-eval
        //amount = eval(roundFunction.replace("amount", t.amount));

        if (t.currency === "EUR" && paymentMethod.method.type === "cash")
            url += "\\6|1|" + Math.round(100 * t.amount) / 100;
        else
            url += "\\6|" + paymentMethods[paymentMethod.method.type] + "|" + amount;
    });

    url += "\r\n";

    if (types.filter(t => t.amount > 0).length === 0) url = "";

    console.log(url);
    def.resolve(url);
}

export const storno_sam4s = (data) => {
    data.originalDate = "2025.03.13 09:26";
    return `PTG|1\\7|0|${data.customerName}|${data.customerPostCode}|${data.customerTown}|${data.customerAddress}||||${data.originalDate}|NY/${data.ap}/${data.receiptNumber}|S${data.reason}\r\n`;
}

export const cashin_sam4s = (reason, amount) => {
    return `PTG|1\\9|0|1|${reason}|${amount}\r\n`;
}

export const cashout_sam4s = (reason, amount) => {
    return `PTG|1\\9|1|1|${reason}|${amount}\r\n`;
}

export const dayOpen_sam4s = (amount) => {
    return { text: `PTG|1|\\10|${amount}\r\n` };
}
export const dayClose_sam4s = () => {
    return { text: `PTG|1|\\11\r\n` };
}
